import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import { CloudTypeEnum } from '@src/endpoints/services/base.service'
import { compact, includes, isEmpty } from 'lodash'

const devHostnames = [
  '.cam.cloud.sailpoint.com',
  '.cam.fedramp-dev.identitysoon.com'
]

export function extractHost(url: string) {
  let hostname = null
  let protocol = null
  const value = url || ''
  if (value.indexOf('//') > -1) {
    protocol = value.split('/')[0]
    hostname = value.split('/')[2]
  } else {
    hostname = value.split('/')[0]
  }
  hostname = hostname.split(':')[0]
  hostname = hostname.split('?')[0]
  if (protocol) {
    return `${protocol}//${hostname}`
  }
  return hostname
}

export const UNKNOWN_URL_PARAM = '-'

export function parseURIParam<T extends string>(param: T) {
  return !isEmpty(param) ? param : UNKNOWN_URL_PARAM
}

export function getHostname(): string {
  const { hostname = '' } = window?.location
  return window.__HOST__ || hostname
}

export function getURITenant() {
  const hostname = getHostname()
  return (hostname.split('.') || [])[0] ?? hostname
}

export const isCloud = () => {
  const hostname = getHostname()
  return devHostnames.some(h => includes(hostname, h))
}

export function getURIParam<T extends string>(param: T) {
  return param !== UNKNOWN_URL_PARAM ? param : ''
}

export function getUriFromPathName(pathname: string): string {
  const parts = compact((pathname || '').split('/'))
  if (parts?.length > 6) {
    const tenantId = parts[1]
    const cloudType = parts[2]
    const accountId = parts[3]
    const region = parts[4]
    let type
    let id
    if (parts.length > 7) {
      if (parts[8]?.split(':').length > 5) {
        return decodeURIComponent(parts[8])
      }
      type = parts[6]
      id = decodeURIComponent(parts[7])
    } else {
      type = parts[5]
      id = decodeURIComponent(parts[6])
    }
    return `${tenantId}:${cloudType}:${accountId}:${region}:${type}:${id}`
  }
  return null
}

export interface ParseCamURIResp {
  tenantId?: string
  cloudType?: CloudTypeEnum
  accountId?: string
  region?: string
  type?: ResourceTypeEnum
  id?: string
}

function parseCamURI(uri: string): ParseCamURIResp {
  const parts = (uri || '').split(':')
  // CAM URI contains 6 parts, no more no less
  if (parts.length !== 6) {
    return null
  }
  return {
    tenantId: parts[0],
    cloudType: CloudTypeEnum[parts[1]] || parts[1],
    accountId: parts[2],
    region: parseURIParam(parts[3]),
    type: ResourceTypeEnum[parts[4]] || parts[4],
    id: parts[5]
  }
}

function getTypeFromUri(uri: string) {
  const parsedURI = parseCamURI(uri)
  return parsedURI.type
}

function getIdFromUri(uri: string) {
  const parsedURI = parseCamURI(uri)
  return skipPath(parsedURI?.id)
}

function getAccountIdFromUri(uri: string) {
  const parsedURI = parseCamURI(uri)
  return skipPath(parsedURI?.accountId)
}

function skipPath(id: string) {
  const parts = (id || '').split('/')
  return parts[parts.length - 1]
}

function getRegionFromUri(uri: string) {
  const parsedURI = parseCamURI(uri)
  return parsedURI?.region
}

function removePolicyPrefix(policy: string) {
  const parts = (policy || '').split(':')
  return parts[parts.length - 1]
}

function getQuery() {
  const urlSearchParams: URLSearchParams = new URLSearchParams(
    window?.location?.search || ''
  )
  const query = {}
  urlSearchParams.forEach((value, key, parent) => {
    query[key] = value
  })
  return query
}

export {
  parseCamURI,
  skipPath,
  getIdFromUri,
  getTypeFromUri,
  getRegionFromUri,
  getAccountIdFromUri,
  removePolicyPrefix,
  getQuery
}
export default {
  parseCamURI,
  skipPath,
  getAccountIdFromUri,
  getIdFromUri,
  getTypeFromUri,
  getRegionFromUri,
  removePolicyPrefix,
  getQuery
}
